import React, { useState } from 'react';
import {
  Card, Button, Table, Form, Input, Select, Tag, Space, Typography,
  Modal, Upload, Image, Radio, Divider, Drawer, message
} from 'antd';
import {
  SearchOutlined, ReloadOutlined, PlusOutlined, EditOutlined,
  DeleteOutlined, UploadOutlined, ArrowUpOutlined, ArrowDownOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const LANGUAGES = [
  { value: 1, label: '中文' }, { value: 2, label: 'English' },
  { value: 3, label: 'Français' }, { value: 4, label: 'Deutsch' },
  { value: 6, label: 'Español' }, { value: 8, label: 'Italiano' },
  { value: 9, label: 'Português' }, { value: 13, label: '日本語' },
];

const WIFI_MODES = [
  { value: '1', label: 'AP' }, { value: '2', label: '声音' },
  { value: '3', label: 'SmartLink' }, { value: '4', label: '摄像机识别二维码' },
  { value: '5', label: '局域网' }, { value: '6', label: 'App扫码' },
  { value: '7', label: '蓝牙' },
];

const MEDIA_TYPES = [
  { value: '2', label: 'GIF动图' }, { value: '3', label: '图片' },
];

const mockData = [
  {
    key: '1', id: 1, language: 1, updatedTime: '2025-05-15 16:51:11',
    products: [
      { productId: 'T8HxbfONIDUAIntp', productName: '智能摄像机Q1', addedTime: '2025-05-15 16:51:11' },
      { productId: 'PROD_P1', productName: '云台机P1', addedTime: '2025-06-01 10:00:00' },
    ],
    unitInfo: {
      Title: 'Glascam G10', Desc: 'G10', Icon: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/002/icon.png',
      PriorMode: '',
      WifiSetModes: [{ Mode: '1' }, { Mode: '7' }, { Mode: '5' }],
      Guide: {
        Icon: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/001/setup02_01.png',
        InstallUrl: '',
        StepList: [
          { Step: 1, Title: '', Desc: '将随附的充电器电缆和适配器连接到电源插座。另一端连接到摄像头，保证设备通电成功。', ConfirmButtonSwitch: 0, HelpSwitch: 0, Media: { Type: '2', Url: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/002/step01.gif' } },
          { Step: 2, Title: '', Desc: '等待1分钟或直到摄像头上的LED指示灯闪烁蓝色。', ConfirmButtonSwitch: 0, HelpSwitch: 1, Media: { Type: '2', Url: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/002/step02.gif' },
            Help: { Title: '指示灯不闪烁蓝色？', Type: '1', Url: '', StepList: [{ Step: 1, Desc: '请按重置按钮5秒重置摄像头。', Media: { Type: '2', Url: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/002/step03.gif' } }] } },
        ],
      },
    },
  },
  {
    key: '2', id: 10, language: 13, updatedTime: '2025-07-29 14:51:34',
    products: [
      { productId: 'T8H6EJg8KurXmNN3', productName: '户外摄像机C2', addedTime: '2025-07-29 14:51:34' },
    ],
    unitInfo: {
      Title: 'Alaga K10', Desc: 'K10', Icon: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/005/icon.png',
      PriorMode: '3',
      WifiSetModes: [{ Mode: '1' }, { Mode: '2' }, { Mode: '6' }],
      Guide: { StepList: [
        { Step: 1, Title: '', Desc: '将充电器连接到电源插座', ConfirmButtonSwitch: 0, HelpSwitch: 0, Media: { Type: '2', Url: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/005/step01.gif' } },
        { Step: 2, Title: '', Desc: '等待LED指示灯闪烁蓝色', ConfirmButtonSwitch: 0, HelpSwitch: 1, Media: { Type: '2', Url: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/005/step02_help.gif' },
          Help: { Title: '指示灯不闪烁蓝色？', Type: '1', Url: '', StepList: [{ Step: 1, Desc: '请按重置按钮5秒', Media: { Type: '2', Url: 'https://hmstatic-1311597033.cos.ap-nanjing.myqcloud.com/guide/conn_net/005/step02_light.gif' } }] } },
      ] },
    },
  },
];

const ALL_PRODUCTS = [
  { value: 'T8HxbfONIDUAIntp', label: '智能摄像机Q1' },
  { value: 'PROD_P1', label: '云台机P1' },
  { value: 'PROD_F1', label: '烟雾报警器F1' },
  { value: 'PROD_S1', label: '智能门锁S1' },
  { value: 'T8H6EJg8KurXmNN3', label: '户外摄像机C2' },
  { value: 'T8HMFj0yauUIg73d', label: '4G摄像机M1' },
];

const langMap = Object.fromEntries(LANGUAGES.map(l => [l.value, l.label]));
const modeMap = Object.fromEntries(WIFI_MODES.map(m => [m.value, m.label]));

const NetworkUnit = () => {
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [stepForm] = Form.useForm();
  const [dataSource, setDataSource] = useState(mockData);
  // 主表单
  const [editVisible, setEditVisible] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  // 步骤管理
  const [stepVisible, setStepVisible] = useState(false);
  const [stepRecord, setStepRecord] = useState(null);
  const [stepList, setStepList] = useState([]);
  const [stepEditVisible, setStepEditVisible] = useState(false);
  const [editStepIdx, setEditStepIdx] = useState(null);
  // 关联产品
  const [productDrawerVisible, setProductDrawerVisible] = useState(false);
  const [productRecord, setProductRecord] = useState(null);
  const [addProductVisible, setAddProductVisible] = useState(false);
  const [addProductValue, setAddProductValue] = useState(null);

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    {
      title: '配网单元', key: 'unit', width: 220,
      render: (_, r) => (
        <Space>
          {r.unitInfo.Icon && <Image src={r.unitInfo.Icon} width={36} height={36} style={{ borderRadius: 6, objectFit: 'cover' }} preview={false} fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/+F/PQAJpAN42kRrYAAAAABJRU5ErkJggg==" />}
          <div>
            <div style={{ fontWeight: 500 }}>{r.unitInfo.Title || '—'}</div>
            <Text type="secondary" style={{ fontSize: 12 }}>{r.unitInfo.Desc || ''}</Text>
          </div>
        </Space>
      ),
    },
    { title: '语言', dataIndex: 'language', width: 80, render: (v) => <Tag>{langMap[v] || v}</Tag> },
    {
      title: '配网模式', key: 'modes', width: 220,
      render: (_, r) => (
        <Space size={[4, 4]} wrap>
          {(r.unitInfo.WifiSetModes || []).map((m, i) => <Tag key={i} color="blue">{modeMap[m.Mode || m.Model] || m.Mode || m.Model}</Tag>)}
        </Space>
      ),
    },
    { title: '优先模式', key: 'prior', width: 100, render: (_, r) => r.unitInfo.PriorMode ? <Tag color="orange">{modeMap[r.unitInfo.PriorMode] || r.unitInfo.PriorMode}</Tag> : <Text type="secondary">无</Text> },
    { title: '配置步骤', key: 'steps', width: 100, align: 'center', render: (_, r) => <Button type="link" size="small" onClick={() => openSteps(r)}>{r.unitInfo.Guide?.StepList?.length || 0} 步 <EditOutlined style={{ fontSize: 11, marginLeft: 4 }} /></Button> },
    {
      title: '关联产品', key: 'products', width: 120,
      render: (_, r) => (
        <Button type="link" size="small" style={{ padding: 0 }} onClick={() => { setProductRecord(r); setProductDrawerVisible(true); }}>
          {(r.products || []).length}个 <EditOutlined style={{ fontSize: 11, marginLeft: 4 }} />
        </Button>
      ),
    },
    { title: '更新时间', dataIndex: 'updatedTime', width: 170 },
    {
      title: '操作', key: 'action', width: 200, fixed: 'right',
      render: (_, r) => (
        <Space size={0} split={<span style={{ color: '#d9d9d9', margin: '0 4px' }}>|</span>}>
          <Button type="link" size="small" style={{ padding: 0 }} icon={<EditOutlined />} onClick={() => openEdit(r)}>编辑</Button>
          <Button type="link" size="small" danger style={{ padding: 0 }} icon={<DeleteOutlined />} onClick={() => handleDelete(r)}>删除</Button>
        </Space>
      ),
    },
  ];

  // === 主表单 ===
  const openEdit = (record) => {
    setEditRecord(record || null);
    const info = record?.unitInfo || {};
    editForm.setFieldsValue({
      language: record?.language,
      title: info.Title || '', desc: info.Desc || '',
      icon: info.Icon || '', priorMode: info.PriorMode || undefined,
      wifiModes: (info.WifiSetModes || []).map(m => m.Mode || m.Model),
      guideIcon: info.Guide?.Icon || '', installUrl: info.Guide?.InstallUrl || '',
    });
    setEditVisible(true);
  };

  const handleEditSave = () => {
    editForm.validateFields().then((v) => {
      const guide = editRecord?.unitInfo?.Guide || { StepList: [] };
      const unitInfo = {
        Title: v.title, Desc: v.desc, Icon: v.icon, PriorMode: v.priorMode || '',
        WifiSetModes: (v.wifiModes || []).map(m => ({ Mode: m })),
        Guide: { ...guide, Icon: v.guideIcon || '', InstallUrl: v.installUrl || '' },
      };
      if (editRecord) {
        setDataSource(prev => prev.map(d => d.key === editRecord.key ? { ...d, language: v.language, unitInfo } : d));
        message.success('已更新');
      } else {
        setDataSource(prev => [...prev, { key: String(Date.now()), id: prev.length + 1, language: v.language, updatedTime: new Date().toISOString().replace('T', ' ').slice(0, 19), unitInfo: { ...unitInfo, Guide: { ...unitInfo.Guide, StepList: [] } } }]);
        message.success('已创建');
      }
      setEditVisible(false);
    });
  };

  const handleDelete = (record) => {
    Modal.confirm({ title: '确认删除', content: `删除「${record.unitInfo.Title || ''}」？`, okText: '删除', okType: 'danger', cancelText: '取消',
      onOk: () => { setDataSource(prev => prev.filter(d => d.key !== record.key)); message.success('已删除'); },
    });
  };

  // === 步骤管理 ===
  const openSteps = (record) => {
    setStepRecord(record);
    setStepList(JSON.parse(JSON.stringify(record.unitInfo.Guide?.StepList || [])));
    setStepVisible(true);
  };

  const openStepEdit = (idx) => {
    const s = idx < stepList.length ? stepList[idx] : {};
    stepForm.setFieldsValue({
      title: s.Title || '', desc: s.Desc || '',
      mediaType: s.Media?.Type || '2', mediaUrl: s.Media?.Url || '',
      confirmButtonSwitch: s.ConfirmButtonSwitch || 0, helpSwitch: s.HelpSwitch || 0,
      helpTitle: s.Help?.Title || '', helpType: s.Help?.Type || '1', helpUrl: s.Help?.Url || '',
      helpDesc: s.Help?.StepList?.[0]?.Desc || '', helpMediaType: s.Help?.StepList?.[0]?.Media?.Type || '2',
      helpMediaUrl: s.Help?.StepList?.[0]?.Media?.Url || '',
    });
    setEditStepIdx(idx);
    setStepEditVisible(true);
  };

  const saveStep = () => {
    stepForm.validateFields().then((v) => {
      const arr = [...stepList];
      const step = { Step: 0, Title: v.title, Desc: v.desc, Media: { Type: v.mediaType, Url: v.mediaUrl }, ConfirmButtonSwitch: v.confirmButtonSwitch, HelpSwitch: v.helpSwitch };
      if (v.helpSwitch) {
        step.Help = { Title: v.helpTitle, Type: v.helpType, Url: v.helpUrl, StepList: [{ Step: 1, Desc: v.helpDesc, Media: { Type: v.helpMediaType, Url: v.helpMediaUrl } }] };
      }
      if (editStepIdx < arr.length) { arr[editStepIdx] = { ...arr[editStepIdx], ...step }; } else { arr.push(step); }
      arr.forEach((s, i) => { s.Step = i + 1; });
      setStepList(arr);
      setStepEditVisible(false);
    });
  };

  const saveStepList = () => {
    setDataSource(prev => prev.map(d => d.key === stepRecord.key ? { ...d, unitInfo: { ...d.unitInfo, Guide: { ...d.unitInfo.Guide, StepList: stepList } } } : d));
    setStepVisible(false);
    message.success('步骤已保存');
  };

  const moveStep = (idx, dir) => {
    const arr = [...stepList]; const t = idx + dir;
    if (t < 0 || t >= arr.length) return;
    [arr[idx], arr[t]] = [arr[t], arr[idx]];
    arr.forEach((s, i) => { s.Step = i + 1; });
    setStepList(arr);
  };

  const deleteStep = (idx) => { const arr = stepList.filter((_, i) => i !== idx); arr.forEach((s, i) => { s.Step = i + 1; }); setStepList(arr); };

  // === 关联产品 ===
  const handleAddProduct = () => {
    if (!addProductValue) { message.warning('请选择产品'); return; }
    const prod = ALL_PRODUCTS.find(p => p.value === addProductValue);
    const newProduct = { productId: prod.value, productName: prod.label, addedTime: new Date().toISOString().replace('T', ' ').slice(0, 19) };
    setDataSource(prev => prev.map(d => d.key === productRecord.key ? { ...d, products: [...(d.products || []), newProduct] } : d));
    setProductRecord(prev => ({ ...prev, products: [...(prev.products || []), newProduct] }));
    setAddProductVisible(false);
    setAddProductValue(null);
    message.success('产品已关联');
  };

  const handleRemoveProduct = (productId) => {
    setDataSource(prev => prev.map(d => d.key === productRecord.key ? { ...d, products: (d.products || []).filter(p => p.productId !== productId) } : d));
    setProductRecord(prev => ({ ...prev, products: (prev.products || []).filter(p => p.productId !== productId) }));
    message.success('已移除');
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>配网单元</Title></div>
      <Card bordered={false} style={{ marginBottom: 8 }} bodyStyle={{ padding: '12px 0' }}>
        <Form form={form} layout="inline" style={{ flexWrap: 'wrap', gap: '8px 0' }}>
          <Form.Item name="keyword" style={{ marginRight: 8 }}><Input placeholder="标题/描述" allowClear style={{ width: 180 }} /></Form.Item>
          <Form.Item name="language" style={{ marginRight: 8 }}>
            <Select placeholder="语言" allowClear style={{ width: 120 }}>{LANGUAGES.map(l => <Option key={l.value} value={l.value}>{l.label}</Option>)}</Select>
          </Form.Item>
          <Form.Item style={{ marginRight: 8 }}>
            <Space.Compact>
              <Form.Item name="productSearchType" initialValue="name" noStyle>
                <Select style={{ width: 100 }}>
                  <Option value="name">关联产品</Option>
                  <Option value="id">产品ID</Option>
                </Select>
              </Form.Item>
              <Form.Item noStyle shouldUpdate={(p, c) => p.productSearchType !== c.productSearchType}>
                {({ getFieldValue }) => getFieldValue('productSearchType') === 'id'
                  ? <Form.Item name="productKeyword" noStyle><Input placeholder="产品ID" allowClear style={{ width: 180 }} /></Form.Item>
                  : <Form.Item name="productKeyword" noStyle><Select showSearch optionFilterProp="label" placeholder="选择产品" allowClear style={{ width: 180 }}>{ALL_PRODUCTS.map(p => <Option key={p.value} value={p.value} label={p.label}>{p.label}</Option>)}</Select></Form.Item>
                }
              </Form.Item>
            </Space.Compact>
          </Form.Item>
          <Form.Item><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
        </Form>
      </Card>
      <Card bordered={false}>
        <div style={{ marginBottom: 12 }}><Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditRecord(null); editForm.resetFields(); setEditVisible(true); }}>新增配网单元</Button></div>
        <Table columns={columns} dataSource={dataSource} rowKey="key" scroll={{ x: 'max-content' }} pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      {/* 新增/编辑主表单 */}
      <Drawer title={editRecord ? '编辑配网单元' : '新增配网单元'} open={editVisible} onClose={() => setEditVisible(false)} width={640} destroyOnClose
        footer={<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}><Button onClick={() => setEditVisible(false)}>取消</Button><Button type="primary" onClick={handleEditSave}>保存</Button></div>}>
        <Form form={editForm} layout="vertical">
          <Divider orientation="left" plain>基本信息</Divider>
          <Form.Item name="language" label="语言" rules={[{ required: true, message: '请选择' }]}>
            <Select placeholder="请选择语言">{LANGUAGES.map(l => <Option key={l.value} value={l.value}>{l.label}</Option>)}</Select>
          </Form.Item>
          <Form.Item name="title" label="标题" rules={[{ required: true, message: '请输入' }]}><Input placeholder="如：Glascam G10" /></Form.Item>
          <Form.Item name="desc" label="描述"><Input placeholder="简短描述，如：G10" /></Form.Item>
          <Form.Item name="icon" label="配网图标">
            <Upload maxCount={1} beforeUpload={() => false} listType="picture"><Button icon={<UploadOutlined />}>上传图标</Button></Upload>
          </Form.Item>

          <Divider orientation="left" plain>配网模式</Divider>
          <Form.Item name="wifiModes" label="支持的配网模式" rules={[{ required: true, message: '请选择' }]}>
            <Select mode="multiple" placeholder="请选择">{WIFI_MODES.map(m => <Option key={m.value} value={m.value}>{m.label}</Option>)}</Select>
          </Form.Item>
          <Form.Item name="priorMode" label="优先配网模式">
            <Select placeholder="无优先" allowClear>{WIFI_MODES.map(m => <Option key={m.value} value={m.value}>{m.label}</Option>)}</Select>
          </Form.Item>

          <Divider orientation="left" plain>引导页配置</Divider>
          <Form.Item name="guideIcon" label="引导页图标">
            <Upload maxCount={1} beforeUpload={() => false} listType="picture"><Button icon={<UploadOutlined />}>上传引导图标</Button></Upload>
          </Form.Item>
          <Form.Item name="installUrl" label="安装说明链接"><Input placeholder="安装说明URL（选填）" /></Form.Item>
        </Form>
      </Drawer>

      {/* 配网步骤管理 */}
      <Drawer title={`配网步骤 — ${stepRecord?.unitInfo?.Title || ''}`} open={stepVisible} onClose={() => setStepVisible(false)} width={850} destroyOnClose
        footer={<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}><Button onClick={() => setStepVisible(false)}>取消</Button><Button type="primary" onClick={saveStepList}>保存步骤</Button></div>}>
        <div style={{ marginBottom: 12 }}>
          <Button type="primary" size="small" icon={<PlusOutlined />} onClick={() => { setEditStepIdx(stepList.length); stepForm.resetFields(); stepForm.setFieldsValue({ helpSwitch: 0, confirmButtonSwitch: 0, mediaType: '2', helpType: '1', helpMediaType: '2' }); setStepEditVisible(true); }}>添加步骤</Button>
        </div>
        <Table size="small" dataSource={stepList.map((s, i) => ({ ...s, _idx: i }))} rowKey="_idx" pagination={false} style={{ whiteSpace: 'nowrap' }}
          columns={[
            { title: '步骤', dataIndex: 'Step', width: 50, align: 'center' },
            { title: '标题', dataIndex: 'Title', width: 100, render: (v) => v || <Text type="secondary">—</Text> },
            { title: '描述', dataIndex: 'Desc', ellipsis: true },
            { title: '媒体', key: 'media', width: 70, render: (_, r) => r.Media?.Url ? <Image src={r.Media.Url} width={44} height={44} style={{ objectFit: 'cover', borderRadius: 4 }} /> : '—' },
            { title: '确认按钮', dataIndex: 'ConfirmButtonSwitch', width: 70, align: 'center', render: (v) => v ? <Tag color="green">开</Tag> : <Tag>关</Tag> },
            { title: '帮助', dataIndex: 'HelpSwitch', width: 50, align: 'center', render: (v) => v ? <Tag color="blue">有</Tag> : <Tag>无</Tag> },
            {
              title: '操作', key: 'action', width: 150,
              render: (_, r) => (
                <Space size={4}>
                  <Button type="link" size="small" style={{ padding: 0 }} onClick={() => openStepEdit(r._idx)}>编辑</Button>
                  <Button type="link" size="small" style={{ padding: 0 }} icon={<ArrowUpOutlined />} disabled={r._idx === 0} onClick={() => moveStep(r._idx, -1)} />
                  <Button type="link" size="small" style={{ padding: 0 }} icon={<ArrowDownOutlined />} disabled={r._idx === stepList.length - 1} onClick={() => moveStep(r._idx, 1)} />
                  <Button type="link" size="small" danger style={{ padding: 0 }} onClick={() => deleteStep(r._idx)}>删除</Button>
                </Space>
              ),
            },
          ]}
        />
      </Drawer>

      {/* 单步编辑 */}
      <Modal title={editStepIdx !== null && editStepIdx < stepList.length ? `编辑步骤 ${editStepIdx + 1}` : '添加步骤'} open={stepEditVisible} onCancel={() => setStepEditVisible(false)} width={640} destroyOnClose
        onOk={saveStep} okText="确定" cancelText="取消">
        <Form form={stepForm} layout="vertical" style={{ marginTop: 8 }}>
          <Form.Item name="title" label="步骤标题"><Input placeholder="步骤标题（选填）" /></Form.Item>
          <Form.Item name="desc" label="步骤描述" rules={[{ required: true, message: '请输入' }]}><TextArea rows={3} placeholder="引导用户的操作说明" /></Form.Item>
          <Form.Item name="mediaType" label="媒体类型"><Select options={MEDIA_TYPES} /></Form.Item>
          <Form.Item name="mediaUrl" label="步骤媒体">
            <Upload maxCount={1} beforeUpload={() => false} listType="picture"><Button icon={<UploadOutlined />}>上传GIF/图片</Button></Upload>
          </Form.Item>
          <Form.Item name="confirmButtonSwitch" label="确认按钮"><Radio.Group><Radio value={0}>不显示</Radio><Radio value={1}>显示</Radio></Radio.Group></Form.Item>

          <Divider plain>帮助 / 故障排查（子集）</Divider>
          <Form.Item name="helpSwitch" label="帮助入口"><Radio.Group><Radio value={0}>关闭</Radio><Radio value={1}>开启</Radio></Radio.Group></Form.Item>
          <Form.Item noStyle shouldUpdate={(p, c) => p.helpSwitch !== c.helpSwitch}>
            {({ getFieldValue }) => getFieldValue('helpSwitch') === 1 ? (
              <>
                <Form.Item name="helpTitle" label="帮助标题" rules={[{ required: true, message: '请输入' }]}><Input placeholder="如：指示灯不闪烁蓝色？" /></Form.Item>
                <Form.Item name="helpType" label="帮助类型"><Select options={[{ value: '1', label: '内嵌步骤' }]} /></Form.Item>
                <Form.Item name="helpUrl" label="外部帮助链接"><Input placeholder="外部链接（选填）" /></Form.Item>
                <Divider dashed plain>帮助子步骤</Divider>
                <Form.Item name="helpDesc" label="排查描述" rules={[{ required: true, message: '请输入' }]}><TextArea rows={2} placeholder="排查操作说明" /></Form.Item>
                <Form.Item name="helpMediaType" label="帮助媒体类型"><Select options={MEDIA_TYPES} /></Form.Item>
                <Form.Item name="helpMediaUrl" label="帮助媒体">
                  <Upload maxCount={1} beforeUpload={() => false} listType="picture"><Button icon={<UploadOutlined />}>上传帮助GIF/图片</Button></Upload>
                </Form.Item>
              </>
            ) : null}
          </Form.Item>
        </Form>
      </Modal>

      {/* 关联产品 */}
      <Drawer title={`关联产品 — ${productRecord?.unitInfo?.Title || ''}`} open={productDrawerVisible} onClose={() => setProductDrawerVisible(false)} width={850} destroyOnClose>
        <div style={{ marginBottom: 12 }}>
          <Button type="primary" size="small" icon={<PlusOutlined />} onClick={() => { setAddProductValue(null); setAddProductVisible(true); }}>添加产品</Button>
        </div>
        <Table size="small" dataSource={productRecord?.products || []} rowKey="productId" pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
          columns={[
            { title: '产品名称', dataIndex: 'productName' },
            { title: '产品ID', dataIndex: 'productId', width: 180, render: (v) => <Text copyable style={{ fontSize: 12 }}>{v}</Text> },
            { title: '添加时间', dataIndex: 'addedTime', width: 170 },
            { title: '操作', key: 'action', width: 70, render: (_, r) => <Button type="link" size="small" danger style={{ padding: 0 }} onClick={() => handleRemoveProduct(r.productId)}>移除</Button> },
          ]}
        />
      </Drawer>

      {/* 新增关联产品 */}
      <Modal title="新增关联产品" open={addProductVisible} onCancel={() => setAddProductVisible(false)} destroyOnClose
        onOk={handleAddProduct} okText="确定" cancelText="取消">
        <div style={{ marginTop: 16 }}>
          <div style={{ marginBottom: 12, padding: '8px 12px', background: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: 6, fontSize: 13 }}>
            支持添加该配网单元中的配网模式产品（{(productRecord?.unitInfo?.WifiSetModes || []).map(m => modeMap[m.Mode || m.Model] || m.Mode || m.Model).join('、')}）
          </div>
          <Select showSearch optionFilterProp="label" placeholder="搜索并选择产品" style={{ width: '100%' }}
            value={addProductValue} onChange={setAddProductValue}>
            {ALL_PRODUCTS.map(p => {
              const exists = (productRecord?.products || []).some(ep => ep.productId === p.value);
              return (
                <Option key={p.value} value={p.value} disabled={exists} label={p.label}>
                  {p.label} <Text type="secondary" style={{ fontSize: 12 }}>({p.value})</Text>
                  {exists && <Tag style={{ marginLeft: 8 }} color="default">已关联</Tag>}
                </Option>
              );
            })}
          </Select>
        </div>
      </Modal>

    </div>
  );
};

export default NetworkUnit;
